import React, {Component} from "react";
import {Multiselect} from "multiselect-react-dropdown";
import ReactDOM from "react-dom";
import {Container, Row, Col, Table, Card, Form, Button, Image, ButtonGroup, DropdownButton, Tab, Tabs, Dropdown, Navbar, Modal} from "react-bootstrap";
import {FaCheckCircle, FaTimesCircle, FaPlus, FaHospital, FaPencilAlt} from "react-icons/fa";
import {DatePicker, Switch} from "antd";
import "antd/dist/antd.css";
import Crypt from "../lib/Crypt";
import moment from "moment";
import C from "../lib/Config";

const dateFormat = "DD/MM/yyyy";

export default class EditDoc extends Component {
  constructor(props) {
    super(props);
    this.state = {
      context: this,
      userId: localStorage.getItem("userId"),
      firstName: "",
      lastName: "",
      username: "",
      dob: "",
      phoneNumber: "",
      genderId: "",
      genderName: "",
      genderArr: [],
      userInfo: "",
      address: "",
      countryCode: "",
      profDegreeId: "",
      profDegreeName: "",
      countryArr: [],
      specialityMstArr: [],
      profDegreeList: [],
      selectedSpecility: "",
      userInstituteXrefList: [],
      profilePictureName: '',
      profilePictureData: localStorage.getItem("profilePictureData") ? localStorage.getItem("profilePictureData") : "",
      isShowAddUpdateInstitue: false,
      isShowAddNewInstituteModal: false,
      isAddInstituteMode: true,
      instituteArr: [],
      instituteDto: {instituteId: null, instituteName: ""},
      countryByIdArr: [],
      countryDto: {countryId: null, countryName: ""},
      stateByIdArr: [],
      stateDto: {stateId: null, stateName: ""},
      cityByIdArr: [],
      cityDto: {cityId: null, cityName: ""},
      isStateDisabled: true,
      isCityDisabled: true,
      isInstituteDisabled: true,
      isContactNoDisabled: true,
      isAddButtonDisabled: true,
      contactNo: "",
      insitituteRowData: null,
      newInstituteName: "",
      newAddrLine1: "",
      newAddrLine2: "",
      newZipPinCode: "",
      newCountryId: null,
      newStateId: null,
      newCityId: null,
      emergencyContactNo: "",
      errors: {},
      isSubmitting: false,
      activeTabKey: props.activeTabKey || "generalInfo",
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.updateUser = this.updateUser.bind(this);
  }
  componentDidMount() {
    this.getUserDetail();
    this.countryMasterApiCall();
    this.profDegreeMasterApiCall();
    this.getAllSpeciality();
    this.getAllGender();
    this.getAllCountries()
  }


  getAllGender = async () => {
    return fetch(C.getUrl() + '/genderMaster/getAllGenders')
      .then(res => res.json())
      .then(res => {
        let data = JSON.parse(res.message);
        let genderData = [
          {
            key: Crypt.getUniqueKey("0"),
            id: "DEFAULT",
            name: "- Select Gender -",
          },
        ];
        data.map((item, index) => {
          let jsonList = new Object();
          jsonList["key"] = Crypt.getUniqueKey(index);
          jsonList["id"] = item.genderId + "";
          jsonList["name"] = item.genderName;
          genderData.push(jsonList);
        });
        this.setState({ genderArr: genderData });
      })
      .catch(err => {
        console.log("Error : " + err);
      });
  };

  
  getUserDetail() {
    return fetch(C.getUrl() + '/user/getUserByUserId/' + this.state.userId)
      .then(res => res.json())
      .then(res => {
        let resObj = res;
        this.setUserDetail(JSON.parse(resObj.message));
      })
      .catch(err => {
        console.log("Error : " + err);
      });
  }
  getAllSpeciality = async () => {
    fetch(C.getUrl() + '/specialityMst/getAll')
      .then(res => res.json())
      .then(res => {
        let data = res;
        var arr = [];
        data.map((item, index) => {
          let jsonList = new Object();
          jsonList["key"] = Crypt.getUniqueKey(index);
          jsonList["id"] = item.specialityId;
          jsonList["name"] = item.specialityName;
          arr.push(jsonList);
        });
        this.setState({specialityMstArr: arr});
      })
      .catch(err => {
        console.log("Error : " + err);
      });
  };
  profDegreeMasterApiCall = async () => {
    fetch(C.getUrl() + '/profDegreeMaster/getAllProfDegreeMasters')
      .then(res => res.json())
      .then(res => {
        let data = JSON.parse(res.message);
        if (data !== null) {
          let profDegreeData = [
            {
              key: Crypt.getUniqueKey("0"),
              id: "DEFAULT",
              label: "- Select Qualification -",
            },
          ];
          data.map((item, index) => {
            let jsonList = new Object();
            jsonList["key"] = Crypt.getUniqueKey(index);
            jsonList["id"] = item.profDegreeId + "";
            jsonList["label"] = item.profDegreeName;
            profDegreeData.push(jsonList);
          });
          this.setState({profDegreeList: profDegreeData});
        }
      })
      .catch(err => {
        console.log("Error : " + err);
        this.setState({setModalShow: true});
      });
  };
  setUserDetail(user) {
    console.log("--- USER DATA : " + JSON.stringify(user));
    this.setState({firstName: user.firstName});
    this.setState({lastName: user.lastName});
    this.setState({username: user.username});
    this.setState({dob: user.dob});
    this.setState({phoneNumber: user.phoneNumber});
    this.setState({userInfo: user.userInfo});
    this.setState({genderId: user.genderDto.genderId + ""});
    this.setState({genderName: user.genderDto.genderName});
    this.setState({address: user.address});
    if (user.userSpecialityXrefDTOList != null && user.userSpecialityXrefDTOList != "undefined") {
      var selectedSpecility = [];
      user.userSpecialityXrefDTOList.map(function (d) {
        selectedSpecility.push({
          id: d.specialityMasterDTO.specialityId,
          name: d.specialityMasterDTO.specialityName,
        });
      });
      this.setState({selectedSpecility: selectedSpecility});
    }
    if (user.userInstituteXrefDTOList != null && user.userInstituteXrefDTOList != "undefined") {
      let userInstituteXrefDTOList = user.userInstituteXrefDTOList.map(item => ({
        ...item,
        instituteMstDTO: {
          ...item.instituteMstDTO,
          activeInactiveStatus: true
        }
      }));
      console.log("--- USER INISTITUE : " + JSON.stringify(userInstituteXrefDTOList));
      this.setState({userInstituteXrefList: userInstituteXrefDTOList});
    }
    if (user.profDegreeDto != null && user.profDegreeDto.profDegreeId != 0) {
      this.setState({profDegreeId: user.profDegreeDto.profDegreeId + ""});
      this.setState({profDegreeName: user.profDegreeDto.profDegreeName});
    }
    if (user.genderDto != null && user.genderDto.genderId != 0) {
      this.setState({ genderId: user.genderDto.genderId + "" });
    }
  }

  getGenderName = () => {};

  countryMasterApiCall = async () => {
    fetch(C.getUrl() + '/countryMaster/getallCountries')
      .then(res => res.json())
      .then(res => {
        let data = JSON.parse(res.message);
        var arr = [];
        data.map((item, index) => {
          let jsonList = new Object();
          let ccode = item.phoneContryCode + "";
          let value = ccode.replace("+", "").trim();
          jsonList["key"] = Crypt.getUniqueKey(index);
          jsonList["id"] = item.countryId + "";
          jsonList["label"] = `${item.countryName} ${item.phoneContryCode}`;
          jsonList["phoneCountryCode"] = `${value}`;
          arr.push(jsonList);
        });
        this.setState({
          countryArr: arr,
          countryCode: arr[0].phoneCountryCode,
        });
      })
      .catch(err => {
        console.log("Error : " + err);
      });
  };
  setDOB(date) {
    if (date) {
      this.setState({dob: date._d});
    } else {
      this.setState({dob: null});
    }
  }

  formateDateForBackend(date) {
    if (date != null && date != "" && date != "undefined") {
      return moment(this.state.dob, ['DD/MM/yyyy', 'YYYY-MM-DD', 'MMM DD, YYYY']).format("YYYY-MM-DD");
    } else {
      return null;
    }
  }

  validateInput = () => {
    let errors = {};
    let formIsValid = true;
  
    // Phone Number validation
    if (!this.state.phoneNumber) {
      formIsValid = false;
      errors["phoneNumber"] = "Phone Number is required";
    } else if (!/^\d{10}$/.test(this.state.phoneNumber)) {
      formIsValid = false;
      errors["phoneNumber"] = "Phone Number must be exactly 10 digits";
    }
  
    this.setState({ errors });
    return formIsValid;
  };
  
  validateForm = () => {
    let formIsValid = true;
    const errors = {};

    // Validate phone number length
    if (!this.state.phoneNumber) {
      formIsValid = false;
      errors["phoneNumber"] = "Contact No. is required";
    } else if (this.state.phoneNumber.length !== 10) {
      formIsValid = false;
      errors["phoneNumber"] = "Contact No. must be exactly 10 digits";
    }

    this.setState({ errors });
    return formIsValid;
  };

  updateUser = async () => {
    if (!this.validateForm()) {
      return; 
    }
    const {profileUpdateSuccess} = this.props;
    var userSpecialityArr = [];
    if (this.state.selectedSpecility !== null && this.state.selectedSpecility.length !== 0) {
      let userId = this.state.userId;
      this.state.selectedSpecility.forEach(function (obj) {
        let data = {
          specialityMasterDTO: {
            specialityId: obj.id + "",
          },
          userDTO: {
            userId: userId + "",
          },
        };
        userSpecialityArr.push(data);
      });
    }
    let data = {
      userId: this.state.userId,
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      dob: this.formateDateForBackend(this.state.dob),
      genderDto: {genderId: this.state.genderId + ""},
      userInfo: this.state.userInfo,
      address: this.state.address,
      phoneNumber: this.state.phoneNumber + "",
      profilePictureName: this.state.profilePictureName,
      profilePictureData: this.state.profilePictureData,
      userSpecialityXrefDTOList: userSpecialityArr,
      profDegreeDto: {
        profDegreeId: this.state.profDegreeId + "",
      },
    };
    console.log("-- UPDATE PROFILE JSON : " + JSON.stringify(data));
    // /user/addOrUpdate is excluded from the fetch interceptor (registration uses it
    // logged out), so the token is attached here for profile updates only.
    let httpStatus = null;
    return fetch(C.getUrl() + '/user/addOrUpdate', {
      method: "POST",
      mode: "cors",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        ...C.getHeaders(),
      },
    })
      .then(res => {
        httpStatus = res.status;
        return res.json();
      })
      .then(res => {
        let obj = res;
        if (httpStatus === 401 || obj.statusCode === 401) {
          this.redirectToLoginOnSessionExpiry();
          return;
        }
        let error = obj.subErrors;
        if (error !== null && error !== "") {
          alert(error);
        } else {
          let result = window.confirm("Profile updated successfully");
          if (result) {
            profileUpdateSuccess(this.state.profilePictureData);
          } else {
            profileUpdateSuccess(this.state.profilePictureData);
          }
        }
      })
      .catch(err => {
        console.log("Error : " + err);
        if (httpStatus === 401) {
          this.redirectToLoginOnSessionExpiry();
        }
      });
  };

  // Same logout steps as Topbar; Login shows logoutMessage on arrival.
  redirectToLoginOnSessionExpiry = () => {
    sessionStorage.setItem('logoutMessage', 'Your session has expired. Please login again.');
    localStorage.clear();
    window.location.hash = '/sign-in';
  };

  handleChange(event) {
    const {instituteArr, cityByIdArr, stateByIdArr, countryByIdArr} = this.state;

    if (event.target.name === "firstName") {
      this.setState({firstName: event.target.value});
    }
    if (event.target.name === "lastName") {
      this.setState({lastName: event.target.value});
    }
    if (event.target.name === "phoneNumber") {
      this.setState({phoneNumber: event.target.value});
    }
    if (event.target.name === "phoneNumber") {
      const isValidPhoneNumber = /^[0-9\b]+$/.test(event.target.value) || event.target.value === ""; // Allow empty input for clearing
      if (isValidPhoneNumber && event.target.value.length <= 10) {
        this.setState({ phoneNumber: event.target.value });
      }
      return; // Exit early for phoneNumber
    }
    if (event.target.name === "userInfo") {
      this.setState({userInfo: event.target.value});
    }
    if (event.target.name === "address") {
      this.setState({address: event.target.value});
    }
    if (event.target.name === "qualification") {
      this.setState({profDegreeId: event.target.value});
    }
    if (event.target.name === "gender") {
      this.setState({ genderId: event.target.value });
    }
    if (event.target.name === "country") {
      this.resetAddInstitueForm();
      const {countryByIdArr} = this.state;
      console.log("--> COUNTRY DROPDOWN SELECTED VALUE: " + event.target.value);
      console.log("--> COUNTRY ARRAY: " + JSON.stringify(countryByIdArr));
      
      countryByIdArr.map((item, index) => {
        if (item.id == event.target.value) {
          console.log("--> COUNTRY MATCHED: " + JSON.stringify(item));
          this.setState({
            countryDto: {
              countryId: event.target.value,
              countryName: item.name,
            },
            isStateDisabled: false,
          });
          this.getStateById(event.target.value);
        }
      });
    }
    if (event.target.name === "state") {
      const {stateByIdArr} = this.state;
      console.log("--> STATE DROPDOWN SELECTED VALUE: " + event.target.value);
      console.log("--> STATE ARRAY: " + JSON.stringify(stateByIdArr));
      
      stateByIdArr.map((item, index) => {
        if (item.id == event.target.value) {
          console.log("--> STATE MATCHED: " + JSON.stringify(item));
          this.setState({
            stateDto: {stateId: event.target.value, stateName: item.name},
            isCityDisabled: false,
          });
          this.getCityById(event.target.value);
        }
      });
    }
    if (event.target.name === "city") {
      const {cityByIdArr} = this.state;
      console.log("--> CITY DROPDOWN SELECTED VALUE: " + event.target.value);
      console.log("--> CITY ARRAY: " + JSON.stringify(cityByIdArr));
      
      cityByIdArr.map((item, index) => {
        if (item.id == event.target.value) {
          console.log("--> CITY MATCHED: " + JSON.stringify(item));
          this.setState({
            cityDto: {cityId: event.target.value, cityName: item.name},
            isInstituteDisabled: false,
          });
          this.getAllInstitute(event.target.value).then((institutes) => {
            console.log("--> INSTITUTES FETCHED: " + JSON.stringify(institutes));
            this.setState({instituteArr: institutes});
          });
        }
      });
    }
    if (event.target.name === "institute") {
      const {instituteArr} = this.state;
      console.log("--> INSTITUTE DROPDOWN SELECTED VALUE: " + event.target.value);
      console.log("--> INSTITUTE ARRAY: " + JSON.stringify(instituteArr));
      
      instituteArr.map((item, index) => {
        if (item.id == event.target.value) {
          console.log("--> INSTITUTE MATCHED: " + JSON.stringify(item));
          this.setState({
            instituteDto: {
              instituteId: event.target.value,
              instituteName: item.name,
            },
            isContactNoDisabled: false,
            isAddButtonDisabled: false,
          });
        }
      });
    }
    if (event.target.name === "contactNo") {
      this.setState({contactNo: event.target.value});
    }
  }
 // Handle form field changes
 handleInputChange = (event) => {
  const {name, value} = event.target;
  console.log("INPUT CHANGED: field =", name, "value =", value);
  this.setState({[name]: value});

  if (name === "newCountryId" && value) {
    console.log("Country selected:", value);
    this.getStateById(value).then(() => {
      console.log("States loaded for country:", value);
      this.setState({
        newStateId: null,
        newCityId: null,
        isCityDisabled: true,
        errors: {},
      });
    });
  }
  
  if (name === "newStateId" && value) {
    console.log("State selected:", value);
    this.getCityById(value).then(() => {
      console.log("Cities loaded for state:", value);
      this.setState({
        newCityId: null,
        errors: {},
      });
    });
  }
  
  if (name === "newCityId") {
    console.log("City selected:", value);
    this.setState({errors: {}});
  }
};
// Validate individual fields
validateInput = () => {
  let errors = {};
  let formIsValid = true;

    // Phone Number validation
    if (!this.state.phoneNumber) {
      formIsValid = false;
      errors["phoneNumber"] = "Contact No. is required";
    } else if (!/^\d{10}$/.test(this.state.phoneNumber)) {
      formIsValid = false;
      errors["phoneNumber"] = "Contact No. must be exactly 10 digits";
    }

  // Institute Name validation
  if (!this.state.newInstituteName) {
    formIsValid = false;
    errors["newInstituteName"] = "Institute Name is required";
  }

  // Address Line 1 validation
  if (!this.state.newAddrLine1) {
    formIsValid = false;
    errors["newAddrLine1"] = "Address Line 1 is required";
  }

  // Pincode validation
  if (!this.state.newZipPinCode) {
    formIsValid = false;
    errors["newZipPinCode"] = "Pincode is required";
  } else if (!/^\d{6}$/.test(this.state.newZipPinCode)) {
    formIsValid = false;
    errors["newZipPinCode"] = "Pincode must be exactly 6 digits";
  }

  // Country validation
  if (!this.state.newCountryId) {
    formIsValid = false;
    errors["newCountryId"] = "Country is required";
  }

  // State validation
  if (!this.state.newStateId) {
    formIsValid = false;
    errors["newStateId"] = "State is required";
  }

  // City validation
  if (!this.state.newCityId) {
    formIsValid = false;
    errors["newCityId"] = "City is required";
  }

// Emergency Contact Number validation
if (!this.state.emergencyContactNo) {
  formIsValid = false;
  errors["emergencyContactNo"] = "Emergency Contact Number is required";
} else if (!/^\d{10}$/.test(this.state.emergencyContactNo)) {
  formIsValid = false;
  errors["emergencyContactNo"] = "Contact Number must be exactly 10 digits";
}

  console.log("VALIDATION RESULT: formIsValid =", formIsValid, "errors =", JSON.stringify(errors));
  this.setState({errors});
  return formIsValid;
};
  setUserSpeciality(selectedSpeciality) {
    this.setState({selectedSpecility: selectedSpeciality});
  }

  addInstituteHandler = () => {
    this.setState({
      isShowAddUpdateInstitue: true,
      isAddInstituteMode: true,
      isInstituteDisabled: true,
      isCountryDisabled: true,
      isStateDisabled: true,
      isCityDisabled: true,
      isContactNoDisabled: true,
      isAddButtonDisabled: true,
      contactNo: "",
    });
    this.getAllCountries();
  };

  updateEmergencyContact = (data, index) => {
    this.setState({
      isShowAddUpdateInstitue: true,
      isAddInstituteMode: false,
      insitituteRowData: data,
    });
    console.log("-- ROW DATA : " + JSON.stringify(data));
  };

  getAllInstitute = async (selectedCityId) => {
    const userId = localStorage.getItem("userId");
    try {
      const res = await fetch(C.getUrl() + "/institute/getAllInstituteByUserId/" + userId);
      
      // Check if response is empty or status is not ok
      if (!res.ok) {
        console.error("Error fetching institutes, status:", res.status);
        return []; 
      }
      
      const responseText = await res.text();
      if (!responseText || responseText.trim().length === 0) {
        console.warn("Empty response from server when fetching institutes");
        return [];
      }
      
      const resObj = JSON.parse(responseText);
      if (!Array.isArray(resObj)) {
        console.error("Expected array response, got:", typeof resObj);
        return [];
      }
      
      const institutes = resObj.filter((item) => item.cityMstDTO && item.cityMstDTO.cityId == selectedCityId);
      return institutes.map((item) => ({ id: item.instituteId, name: item.instituteName }));
    } catch (err) {
      console.error("Error fetching institutes:", err);
      return []; // Return an empty array if there's an error
    }
  };
  

  getAllCountries = async () => {
    return fetch(C.getUrl() + "/countryMaster/getallCountries")
      .then(res => {
        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }
        return res.json();
      })
      .then(res => {
        let resObj = JSON.parse(res.message);
        var arr = [];
        resObj.map(function (d) {
          arr.push({id: d.countryId, name: d.countryName});
        });
        console.log("--> COUNTRY ARR : " + JSON.stringify(arr));
        this.setState({countryByIdArr: arr});
      })
      .catch(err => {
        console.log("Error : " + err);
      });
  };

  getStateById = async countryId => {
    return fetch(C.getUrl() + "/countryMaster/getCountryById/" + countryId)
      .then(res => {
        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }
        return res.json();
      })
      .then(res => {
        let resObj = JSON.parse(res.message);
        let stateList = resObj.stateMasterDTOList;
        var arr = [];
        stateList.map(function (d) {
          arr.push({
            id: d.stateId,
            name: d.stateName,
            cityList: d.cityList !== undefined ? d.cityList : null,
          });
        });
        console.log("--> STATE ARR : " + JSON.stringify(arr));
        this.setState({stateByIdArr: arr});
        return arr;
      })
      .catch(err => {
        console.log("Error fetching states: " + err);
        return [];
      });
  };

  getCityById = async stateId => {
    return new Promise((resolve) => {
      const {stateByIdArr} = this.state;
      stateByIdArr.map((item, index) => {
        if (item.id == stateId) {
          if (item.cityList !== null) {
            let list = item.cityList;
            var arr = [];
            list.map((d, index) => {
              arr.push({id: d.cityId, name: d.cityCode});
            });
            console.log("--> CITY ARR : " + JSON.stringify(arr));
            this.setState({cityByIdArr: arr}, () => {
              resolve(arr);
            });
            return;
          }
        }
      });
      resolve([]);
    });
  };

  resetAddInstitueForm = () => {
    this.setState({
      instituteArr: [],
      instituteDto: {instituteId: null, instituteName: ""},
      stateByIdArr: [],
      stateDto: {stateId: null, stateName: ""},
      cityByIdArr: [],
      cityDto: {cityId: null, cityName: ""},
      isCityDisabled: true,
      isInstituteDisabled: true,
      isContactNoDisabled: true,
      isAddButtonDisabled: true,
      contactNo: "",
    });
  };

  activeInactiveStatusHandler = (status, event, data, idx) => {
    const {userInstituteXrefList} = this.state;
    console.log("--- STATUS : " + status);
    console.log("---- INSTITUE ID : " + data.instituteMstDTO.instituteId);
    console.log("---- INSTITUE NAME : " + data.instituteMstDTO.instituteName);

    let userInstituteXrefDTOList = userInstituteXrefList;
    userInstituteXrefDTOList.map((item, index) => {
      if (idx === index) {
        item.instituteMstDTO.activeInactiveStatus = status;
      }
    });
    console.log("--- UPDATED USER INISTITUE : " + JSON.stringify(userInstituteXrefDTOList));
    this.setState({userInstituteXrefList: userInstituteXrefDTOList});
  };

  addUpdateInstituteFormHandler = async () => {
    const {isAddInstituteMode, insitituteRowData} = this.state;

    // Validate form fields before submission
    if (isAddInstituteMode) {
      console.log("--> VALIDATING FORM DATA");
      console.log("--> countryDto: " + JSON.stringify(this.state.countryDto));
      console.log("--> stateDto: " + JSON.stringify(this.state.stateDto));
      console.log("--> cityDto: " + JSON.stringify(this.state.cityDto));
      console.log("--> instituteDto: " + JSON.stringify(this.state.instituteDto));
      console.log("--> contactNo: " + this.state.contactNo);
      
      if (!this.state.countryDto.countryId || this.state.countryDto.countryId === "DEFAULT") {
        alert("Please select a Country");
        console.log("--> VALIDATION FAILED: Country not selected");
        return;
      }
      if (!this.state.stateDto.stateId || this.state.stateDto.stateId === "DEFAULT") {
        alert("Please select a State");
        console.log("--> VALIDATION FAILED: State not selected");
        return;
      }
      if (!this.state.cityDto.cityId || this.state.cityDto.cityId === "DEFAULT") {
        alert("Please select a City");
        console.log("--> VALIDATION FAILED: City not selected");
        return;
      }
      if (!this.state.instituteDto.instituteId || this.state.instituteDto.instituteId === "DEFAULT") {
        alert("Please select an Institute");
        console.log("--> VALIDATION FAILED: Institute not selected");
        return;
      }
      if (!this.state.contactNo || this.state.contactNo.toString().trim() === "") {
        alert("Please enter Emergency Contact Number");
        console.log("--> VALIDATION FAILED: Contact No empty");
        return;
      }
    }

    let jsonData = new Object();
    jsonData["instituteId"] = isAddInstituteMode ? "" : insitituteRowData.instituteMstDTO.instituteId;
    jsonData["instituteName"] = isAddInstituteMode ? this.state.instituteDto.instituteName : insitituteRowData.instituteMstDTO.instituteName;
    jsonData["countryDTO"] = isAddInstituteMode ? this.state.countryDto : insitituteRowData.instituteMstDTO.countryDTO;
    jsonData["stateMstDTO"] = isAddInstituteMode ? this.state.stateDto : insitituteRowData.instituteMstDTO.stateMstDTO;
    jsonData["cityMstDTO"] = isAddInstituteMode ? this.state.cityDto : insitituteRowData.instituteMstDTO.cityMstDTO;
    jsonData["userDTO"] = {userId: this.state.userId};
    jsonData["emergencyContactNo"] = this.state.contactNo;

    let data = {
      instituteMstDTO: jsonData,
    };

    console.log("--> ADD INSTITUTE JSON : " + JSON.stringify(data));

    return fetch(C.getUrl() + "/institute/addOrUpdate", {
      method: "POST",
      mode: "cors",
      body: JSON.stringify(data.instituteMstDTO),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then(res => res.json())
      .then(res => {
        let obj = res;
        let error = obj.subErrors;
        console.log("--> API RESPONSE: " + JSON.stringify(obj));
        if (error !== null && error !== "") {
          console.log("--> SUBMISSION ERROR : " + error);
          alert("Error: " + error);
        } else {
          console.log("--> SUBMISSION SUCCESS");
          alert("Emergency contact updated successfully");
          // Close modal AFTER successful submission
          this.setState({isShowAddUpdateInstitue: false});
          this.getUserDetail();
          this.countryMasterApiCall();
          this.profDegreeMasterApiCall();
          this.getAllSpeciality();
        }
      })
      .catch(err => {
        console.log("--> SUBMISSION ERROR CATCH : " + err);
        alert("Error submitting form: " + err);
      });
  };
// Validate individual fields
validateInput = () => {
  let errors = {};
  let formIsValid = true;

  if (!this.state.phoneNumber) {
    formIsValid = false;
    errors["phoneNumber"] = "Contact No. is required";
  } else if (!/^\d{10,12}$/.test(this.state.phoneNumber)) {
    // Accept 10 digits (local) or 12 digits (with country code like 91)
    formIsValid = false;
    errors["phoneNumber"] = "Contact No. must be 10-12 digits";
  }

  // Institute Name validation
  if (!this.state.newInstituteName) {
    formIsValid = false;
    errors["newInstituteName"] = "Institute Name is required";
  }

  // Address Line 1 validation
  if (!this.state.newAddrLine1) {
    formIsValid = false;
    errors["newAddrLine1"] = "Address Line 1 is required";
  }

  // Pincode validation
  if (!this.state.newZipPinCode) {
    formIsValid = false;
    errors["newZipPinCode"] = "Pincode is required";
  } else if (!/^\d{6}$/.test(this.state.newZipPinCode)) {
    formIsValid = false;
    errors["newZipPinCode"] = "Pincode must be exactly 6 digits";
  }

  // Country validation
  if (!this.state.newCountryId) {
    formIsValid = false;
    errors["newCountryId"] = "Country is required";
  }

  // State validation
  if (!this.state.newStateId) {
    formIsValid = false;
    errors["newStateId"] = "State is required";
  }

  // City validation
  if (!this.state.newCityId) {
    formIsValid = false;
    errors["newCityId"] = "City is required";
  }

  // Emergency Contact Number validation
  if (!this.state.emergencyContactNo) {
    formIsValid = false;
    errors["emergencyContactNo"] = "Emergency Contact Number is required";
  } else if (!/^\d{10,12}$/.test(this.state.emergencyContactNo)) {
    // Accept 10 digits (local) or 12 digits (with country code)
    formIsValid = false;
    errors["emergencyContactNo"] = "Contact Number must be 10-12 digits";
  }

  this.setState({errors});
  return formIsValid;
};
 // Handle form submission
 submitNewInstitute = async (event) => {
  if (event) {
    event.preventDefault();
  }
  
  if (!this.validateInput()) {
    return;
  }
  
  const {
    newInstituteName,
    newAddrLine1,
    newAddrLine2,
    newZipPinCode,
    newCountryId,
    newStateId,
    newCityId,
    emergencyContactNo,
    userId,
  } = this.state;

  try {
    // Check if the institute already exists for the user
    const existingInstitutes = await this.getAllInstitute(newCityId) || [];

    const isInstituteExist = existingInstitutes.some(
      (institute) =>
        institute.name.toLowerCase() === newInstituteName.trim().toLowerCase()
    );

    if (isInstituteExist) {
      alert("This institute is already assigned to you.");
      return;
    }
    
    const data = {
      instituteName: newInstituteName,
      addrLine1: newAddrLine1,
      addrLine2: newAddrLine2,
      zipPinCode: newZipPinCode,
      countryDTO: {countryId: newCountryId},
      stateMstDTO: {stateId: newStateId},
      cityMstDTO: {cityId: newCityId},
      userDTO: {userId: userId},
      emergencyContactNo: emergencyContactNo,
    };

    const apiUrl = C.getUrl() + "/institute/addOrUpdate";
    const response = await fetch(apiUrl, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
      },
    });

    let responseData = null;
    try {
      const responseText = await response.text();
      if (responseText) {
        responseData = JSON.parse(responseText);
      }
    } catch (parseErr) {
      // Unable to parse response
    }

    if (response.ok && responseData?.statusCode === 200) {
      alert("New Institute Created Successfully!");
      this.setState({ isShowAddNewInstituteModal: false });
      this.getUserDetail();
    } else if (responseData && responseData.message) {
      alert("Error creating institute: " + responseData.message);
    } else {
      alert("Error creating institute. Please try again.");
    }
  } catch (err) {
    alert("Error submitting form: " + err.message);
  }
};
  editProfilePicture = (e) => {
    if (e.target.files[0].name !== undefined) {
      console.log("--> PROFILE PIC :: " + e.target.files[0].name);
      console.log("--> PROFILE PIC [file type] :: " + e.target.files[0].type);
      let file = e.target.files[0];
      let fileType = e.target.files[0].type;
      let validFileType = this.isValidFileType(fileType);
      if (file && validFileType) {
        const reader = new FileReader();
        reader.onload = (readerEvent) => {
          this.fileReaderHandler(readerEvent, fileType);
        };
        reader.readAsBinaryString(file);
        this.setState({
          profilePictureName: e.target.files[0].name,
        });
      }
    }
  };

  fileReaderHandler = (readerEvent, fileType) => {
    let binaryString = readerEvent.target.result;
    let imageData = "data:image/" + fileType.split('/')[1] + ";base64," + btoa(binaryString);
    console.log("--> BASE64 DATA : " + imageData);
    this.setState({
      profilePictureData: imageData,
    });
  };

  isValidFileType = type => {
    switch (type) {
      case "image/png":
        return true;

      case "image/jpeg":
        return true;

      case "image/jpg":
        return true;

      default:
        return false;
    }
  };
  showAddNewInstituteModal = () => {
    console.log("BUTTON CLICKED: Opening Add New Institute Modal");
    this.resetNewInstituteForm();
    this.getAllCountries();
    this.setState({ isShowAddNewInstituteModal: true, errors: {} }, () => {
      console.log("MODAL OPENED: isShowAddNewInstituteModal state =", this.state.isShowAddNewInstituteModal);
    });
  };

  resetNewInstituteForm = () => {
    this.setState({
      newInstituteName: "",
      newAddrLine1: "",
      newAddrLine2: "",
      newZipPinCode: "",
      newCountryId: null,
      newStateId: null,
      newCityId: null,
      isStateDisabled: true,
      isCityDisabled: true,
      emergencyContactNo: "",
      errors: {},
    });
  };
  render() {
    const {
      context,
      countryArr,
      specialityMstArr,
      profDegreeList,
      isShowAddUpdateInstitue,
      isAddInstituteMode,
      isCountryDisabled,
      isStateDisabled,
      isCityDisabled,
      isContactNoDisabled,
      isAddButtonDisabled,
      isInstituteDisabled,
      insitituteRowData,
      stateByIdArr, 
      cityByIdArr,
      errors
    } = this.state;
    const {cancelEdit} = this.props;
    return (
      <section className="section" id="accordion">
        <Row>
          <Col lg="3" md="12">
            <div className="card text-center border-0 pb-0">
              <div className="bg-light"></div>
              <div className="card-body">
                {(() => {
                    if (this.state.profilePictureData !== "undefined" && this.state.profilePictureData !== null && this.state.profilePictureData !== "") {
                        return (
                            <Image src={this.state.profilePictureData} className="rounded-circle profile mb-3" />
                        )
                    }else{
                        return (
                            <Image src={`${process.env.PUBLIC_URL}/img/profile-male.png`} className="rounded-circle profile mb-3" />
                        )
                    }
                })()}
                <div>
                  <Form.Group className="input-group mt-0 mb-2 mt-3">
                    <Form.File type="file" className="p-0" id="inputGroupFile01" style={{width: "100%"}} label="Edit Profile Picture" onChange={e => this.editProfilePicture(e)} />
                  </Form.Group>
                  <h1 className="card-title mt-3">
                    <b>
                      {this.state.firstName} {this.state.lastName}
                    </b>
                  </h1>
                  <p className="card-description font-weight-bold">{this.state.profDegreeName}</p>
                  <Form.Group>
                    <Form.Control as="textarea" placeholder="" name="userInfo" defaultValue={this.state.userInfo} rows={8} onChange={this.handleChange} />
                  </Form.Group>
                </div>
              </div>
            </div>
          </Col>
          <Col lg="9" md="12">
            <div className="card border-0 pb-0">
              <div className="card-body flex-wrap border-0 pb-0">
                <div className="pull-right mt-2">
                  <Button variant="secondary" className="float-right btn-primary" onClick={this.updateUser.bind(this)}>
                    <FaCheckCircle className="mr-2 mb-1" style={{verticalAlign: "bottom"}} />
                    Save
                  </Button>
                  <Button
                    variant="secondary"
                    className="float-right btn-primary mr-2"
                    onClick={() => {
                      cancelEdit();
                    }}
                  >
                    <FaTimesCircle className="mr-2 mb-1" style={{verticalAlign: "bottom"}} />
                    Cancel
                  </Button>
                </div>
                <Tabs activeKey={this.state.activeTabKey} onSelect={(key) => this.setState({ activeTabKey: key })}>
                  <Tab eventKey="generalInfo" title="General Info">
                    <Row className="mt-4 mb-4">
                      <Col lg="4">
                        <Form.Group>
                          <Form.Label>First Name</Form.Label>
                          <Form.Control type="text" defaultValue={this.state.firstName} placeholder="" name="firstName" onChange={this.handleChange} />
                        </Form.Group>
                        <Form.Group>
                          <Form.Label>Email ID</Form.Label>
                          <Form.Control type="email" value={this.state.username} placeholder="" name="email" disabled />
                        </Form.Group>
                        <Form.Group>
                          <Form.Label>Date of Birth</Form.Label>
                          <DatePicker
                            className="form-control full-width25"
                            value={this.state.dob != "" && this.state.dob != null ? moment(this.state.dob, ['DD/MM/yyyy', 'YYYY-MM-DD', 'MMM DD, YYYY']) : ""}
                            onChange={date => this.setDOB(date)}
                            showToday="false"
                            format={dateFormat}
                          />
                        </Form.Group>
                        {/* <Form.Group className="input-group pt-3">
                          <Form.Control as="select" id="" name="country" style={{maxWidth: "100px"}} onChange={this.handleChange}>
                            {countryArr.map((item, i) => {
                              return <option key={item.key} value={item.id}>{`${item.label}`}</option>;
                            })}
                          </Form.Control>
                          <Form.Control type="number" maxLength="10" id="" placeholder="" defaultValue={this.state.phoneNumber} className="ml-2" name="phoneNumber" onChange={this.handleChange} />
                        </Form.Group> */}
                        <Form.Group className="pt-3">
                        <div className="row">
                          <div className="col-md-5">
                            <Form.Label>Country Code</Form.Label>
                            <Form.Control as="select" id="" name="country" style={{ maxWidth: "100px" }} onChange={this.handleChange}>
                              {countryArr.map((item, i) => {
                                return <option key={item.key} value={item.id}>{`${item.label}`}</option>;
                              })}
                            </Form.Control>
                          </div>
                          <div className="col-md-7">
                            <Form.Label>Contact No</Form.Label>
                            <Form.Control
                              type="text"
                              maxLength="10"
                              id=""
                              placeholder="Contact No"
                              value={this.state.phoneNumber}
                              className="ml-2"
                              name="phoneNumber"
                              onChange={this.handleChange}
                              isInvalid={!!this.state.errors.phoneNumber}
                            />
                            <Form.Control.Feedback type="invalid">
                              {this.state.errors.phoneNumber}
                            </Form.Control.Feedback>
                          </div>
                        </div>
                      </Form.Group>

                      </Col>
                      <Col lg="4">
                        <Form.Group>
                          <Form.Label>Last Name</Form.Label>
                          <Form.Control type="text" placeholder="" defaultValue={this.state.lastName} name="lastName" onChange={this.handleChange} />
                        </Form.Group>
                        {/* <Form.Group>
                          <Form.Label>Gender</Form.Label>
                          <Form.Control as="select" id="" name="gender" value={this.state.genderId}>
                            <option value="DEFAULT">- Select Gender -</option>
                            <option value="1">
                              Male
                            </option>
                            <option value="2">Female</option>
                            <option value="3">Do not want to specify</option>
                          </Form.Control>
                        </Form.Group> */}
                        <Form.Group>
                          <Form.Label>Gender</Form.Label>
                          <Form.Control
                            as="select"
                            id="genderSelectBox"
                            name="gender"
                            onChange={this.handleChange}
                            value={this.state.genderId}  // Set the selected gender
                          >
                            {this.state.genderArr.map((item, i) => {
                              return (
                                <option key={item.key} value={item.id}>
                                  {item.name}
                                </option>
                              );
                            })}
                          </Form.Control>
                        </Form.Group>
                        <Form.Group>
                          <Form.Label>Qualification</Form.Label>
                          <Form.Control as="select" id="selectBox" name="qualification" onChange={this.handleChange} value={this.state.profDegreeId}>
                            {profDegreeList.map((item, i) => {
                              return <option key={item.key} value={item.id}>{`${item.label}`}</option>;
                            })}
                          </Form.Control>
                        </Form.Group>
                      </Col>
                      <Col lg="4">
                        <Form.Group>
                          <Form.Label>Address</Form.Label>
                          <Form.Control as="textarea" placeholder="" name="address" defaultValue={this.state.address} rows={4} onChange={this.handleChange} />
                        </Form.Group>
                        <Form.Group>
                          <Form.Label>Speciality</Form.Label>
                          <Multiselect
                            options={this.state.specialityMstArr}
                            selectedValues={this.state.selectedSpecility}
                            onSelect={this.setUserSpeciality.bind(this)}
                            onRemove={this.setUserSpeciality.bind(this)}
                            displayValue="name"
                            placeholder="Select all that apply"
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  </Tab>
                  <Tab eventKey="ProfessionalDegree" title="Associated Institute">
                    <Row className="mt-4">
                      <Col lg="12">
                        <div className="single-item">
                          <table id="example" className="table table-striped table-hover text-nowrap dataTable no-footer" role="grid" aria-describedby="example_info">
                            <thead className="thead-light">
                              <tr role="row">
                                <th className="sorting" aria-controls="example" colSpan="1">
                                  #
                                </th>
                                <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">
                                  Associated Institute
                                </th>
                                <th className="sorting" aria-controls="example" colSpan="1">
                                  City
                                </th>
                                <th className="sorting" aria-controls="example" colSpan="1">
                                  State
                                </th>
                                <th className="sorting" aria-controls="example" colSpan="1">
                                  Country
                                </th>
                                <th className="sorting" aria-controls="example" colSpan="1">
                                  Emergency Contact No.
                                </th>
                                <th className="sorting" aria-controls="example" colSpan="1"></th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.userInstituteXrefList != "undefined" &&
                                this.state.userInstituteXrefList.map(function (d, idx) {
                                  return (
                                    <tr key={idx} role="row" className="odd">
                                      <td>{idx + 1}</td>
                                      <td>{d.instituteMstDTO.instituteName}</td>
                                      <td>{d.instituteMstDTO.cityMstDTO.cityCode}</td>
                                      <td>{d.instituteMstDTO.stateMstDTO.stateName}</td>
                                      <td>{d.instituteMstDTO.countryDTO.countryName}</td>
                                      <td>{d.instituteMstDTO.emergencyContactNo}</td>
                                      <td>
                                        <Button
                                          variant="secondary"
                                          className="btn-primary"
                                          onClick={() => {
                                            context.updateEmergencyContact(d, idx);
                                          }}
                                        >
                                          <FaPencilAlt className="mr-2 mb-1" style={{verticalAlign: "bottom"}} />
                                          Update Emergency Contact
                                        </Button>
                                      </td>
                                    </tr>
                                  );
                                })}
                            </tbody>
                          </table>
                        </div>
                      </Col>
                    </Row>
                    <Row className="mt-2 mb-4">
                      <Col lg="12">
                        {/* <Button
                          variant="secondary"
                          className="float-right btn-primary"
                          onClick={() => {
                            this.addInstituteHandler();
                          }}
                        >
                          <FaPlus className="mr-2 mb-1" style={{verticalAlign: "bottom"}} />
                          Add Institute
                        </Button> */}
                        <Button
                        variant="secondary"
                        className="float-right btn-primary mr-2"
                        onClick={() => this.showAddNewInstituteModal()}
                      >
                        <FaPlus className="mr-2 mb-1" style={{verticalAlign: "bottom"}} />
                        Add New Institute
                      </Button>
                      </Col>
                    </Row>
                  </Tab>
                </Tabs>
              </div>
            </div>
            <Modal show={isShowAddUpdateInstitue} animation={true} size="md">
              <Modal.Header closeButton onClick={() => this.setState({isShowAddUpdateInstitue: false})}>
                <Modal.Title>
                  <h3 className="fs-18 header_title mb-0 text-black">{isAddInstituteMode ? `Add Institute` : `Update Emergency Contact`}</h3>
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Container fluid>
                  <Row>
                    <Col lg="12">
                      <Form.Group>
                        {isAddInstituteMode ? (
                          <>
                            <Form.Label>Country</Form.Label>
                            <Form.Group>
                              <Form.Control as="select" id="" name="country" onChange={this.handleChange}>
                                <option value="DEFAULT" disabled={true}>
                                  - Select Country -
                                </option>
                                {this.state.countryByIdArr.map(function (d) {
                                  return <option value={d.id}>{d.name}</option>;
                                })}
                              </Form.Control>
                            </Form.Group>
                          </>
                        ) : (
                          <>
                            <Form.Label>Country</Form.Label>
                            <Form.Control value={insitituteRowData.instituteMstDTO.countryDTO.countryName} placeholder="" disabled />
                          </>
                        )}
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="12">
                      <Form.Group>
                        {isAddInstituteMode ? (
                          <>
                            <Form.Label>State</Form.Label>
                            <Form.Group>
                              <Form.Control as="select" id="" name="state" onChange={this.handleChange} disabled={isStateDisabled}>
                                <option value="DEFAULT" disabled={true}>
                                  - Select State -
                                </option>
                                {this.state.stateByIdArr.map(function (d) {
                                  return <option value={d.id}>{d.name}</option>;
                                })}
                              </Form.Control>
                            </Form.Group>
                          </>
                        ) : (
                          <>
                            <Form.Label>State</Form.Label>
                            <Form.Control value={insitituteRowData.instituteMstDTO.stateMstDTO.stateName} placeholder="" disabled />
                          </>
                        )}
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="12">
                      <Form.Group>
                        {isAddInstituteMode ? (
                          <>
                            <Form.Label>City</Form.Label>
                            <Form.Group>
                              <Form.Control as="select" id="" name="city" onChange={this.handleChange} disabled={isCityDisabled}>
                                <option value="DEFAULT" disabled={true}>
                                  - Select City -
                                </option>
                                {this.state.cityByIdArr.map(function (d) {
                                  return <option value={d.id}>{d.name}</option>;
                                })}
                              </Form.Control>
                            </Form.Group>
                          </>
                        ) : (
                          <>
                            <Form.Label>City</Form.Label>
                            <Form.Control value={insitituteRowData.instituteMstDTO.cityMstDTO.cityCode} placeholder="" disabled />
                          </>
                        )}
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="12">
                      <Form.Group>
                        {isAddInstituteMode ? (
                          <>
                            <Form.Label>Institute</Form.Label>
                            <Form.Group>
                              <Form.Control as="select" id="" name="institute" onChange={this.handleChange} disabled={isInstituteDisabled}>
                                <option value="DEFAULT" disabled={true}>
                                  - Select Institute -
                                </option>
                                {this.state.instituteArr.map(function (d) {
                                  return <option value={d.id}>{d.name}</option>;
                                })}
                              </Form.Control>
                            </Form.Group>
                          </>
                        ) : (
                          <>
                            <Form.Label>Institute</Form.Label>
                            <Form.Control value={insitituteRowData.instituteMstDTO.instituteName} placeholder="" disabled />
                          </>
                        )}
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="12">
                      <Form.Group>
                        {isAddInstituteMode ? (
                          <>
                            <Form.Label>Emergency Contact No.</Form.Label>
                            <Form.Control
                              type="number"
                              maxLength="10"
                              placeholder="Emergency Contact No"
                              defaultValue={this.state.contactNo}
                              name="contactNo"
                              onChange={this.handleChange}
                              disabled={isContactNoDisabled}
                            />
                          </>
                        ) : (
                          <>
                            <Form.Label>Emergency Contact No.</Form.Label>
                            <Form.Control
                              type="number"
                              maxLength="10"
                              placeholder="Emergency Contact No"
                              defaultValue={typeof insitituteRowData.instituteMstDTO.emergencyContactNo === 'boolean' ? '' : insitituteRowData.instituteMstDTO.emergencyContactNo}
                              name="contactNo"
                              onChange={this.handleChange}
                              disabled={false}
                            />
                          </>
                        )}
                      </Form.Group>
                    </Col>
                  </Row>
                  <div className="text-center mt-2">
                    {isAddInstituteMode ? (
                      <>
                        <Button variant="secondary" className="btn-primary" onClick={() => this.addUpdateInstituteFormHandler()} disabled={isAddButtonDisabled}>
                          <FaPlus className="mr-2 mb-1" style={{verticalAlign: "bottom"}} />
                          Add
                        </Button>
                      </>
                    ) : (
                      <>
                        <Button variant="secondary" className="btn-primary" onClick={() => this.addUpdateInstituteFormHandler()} disabled={false}>
                          <FaPlus className="mr-2 mb-1" style={{verticalAlign: "bottom"}} />
                          Update
                        </Button>
                      </>
                    )}
                  </div>
                </Container>
              </Modal.Body>
            </Modal>
            <Modal show={this.state.isShowAddNewInstituteModal} animation={true} size="md">
            <Modal.Header closeButton onClick={() => this.setState({ isShowAddNewInstituteModal: false })}>
              <Modal.Title>
                <h3 className="fs-18 header_title mb-0 text-black">Add New Institute</h3>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Container fluid>
                <Row>
                  <Col lg="12">
                    <Form.Group>
                      <Form.Label>Institute Name<span className="text-red"> *</span></Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter Institute Name"
                        name="newInstituteName"
                        value={this.state.newInstituteName}
                        onChange={this.handleInputChange}
                      />
                      {errors["newInstituteName"] && (
                    <span className="text-danger">{errors["newInstituteName"]}</span>
                  )}
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col lg="12">
                    <Form.Group>
                      <Form.Label>Emergency Contact Number<span className="text-red"> *</span></Form.Label>
                      <Form.Control
                        type="number"
                        placeholder="Enter Emergency Contact Number"
                        name="emergencyContactNo"
                        value={this.state.emergencyContactNo}
                        onChange={this.handleInputChange}
                        maxLength="10"
                      />
                      {errors["emergencyContactNo"] && (
                        <span className="text-danger">{errors["emergencyContactNo"]}</span>
                      )}
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col lg="12">
                    <Form.Group>
                      <Form.Label>Address Line 1<span className="text-red"> *</span></Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter Address Line 1"
                        name="newAddrLine1"
                        value={this.state.newAddrLine1}
                        onChange={this.handleInputChange}
                      />
                      {errors["newAddrLine1"] && (
                    <span className="text-danger">{errors["newAddrLine1"]}</span>
                  )}
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col lg="12">
                    <Form.Group>
                      <Form.Label>Address Line 2</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter Address Line 2"
                        name="newAddrLine2"
                        value={this.state.newAddrLine2}
                        onChange={this.handleInputChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                
                <Row>
                  <Col lg="12">
                    <Form.Group>
                      <Form.Label>Country<span className="text-red"> *</span></Form.Label>
                      <Form.Control as="select" name="newCountryId" onChange={this.handleInputChange}>
                        <option value="">- Select Country -</option>
                        {this.state.countryByIdArr.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.name}
                          </option>
                        ))}
                      </Form.Control>
                      {errors["newCountryId"] && (
                    <span className="text-danger">{errors["newCountryId"]}</span>
                  )}
                    </Form.Group>
                    <Form.Group>
                      <Form.Label>State<span className="text-red"> *</span></Form.Label>
                      <Form.Control as="select" name="newStateId" onChange={this.handleInputChange} disabled={!this.state.newCountryId}>
                        <option value="">- Select State -</option>
                        {this.state.stateByIdArr.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.name}
                          </option>
                        ))}
                      </Form.Control>
                      {errors["newStateId"] && (
                    <span className="text-danger">{errors["newStateId"]}</span>
                  )}
                    </Form.Group>
                    <Form.Group>
                      <Form.Label>City<span className="text-red"> *</span></Form.Label>
                      <Form.Control as="select" name="newCityId" onChange={this.handleInputChange} disabled={!this.state.newStateId}>
                        <option value="">- Select City -</option>
                        {this.state.cityByIdArr.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.name}
                          </option>
                        ))}
                      </Form.Control>
                      {errors["newCityId"] && (
                    <span className="text-danger">{errors["newCityId"]}</span>
                  )}
                    </Form.Group>

                    <Row>
                  <Col lg="12">
                    <Form.Group>
                      <Form.Label>Pincode<span className="text-red"> *</span></Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter Pincode"
                        name="newZipPinCode"
                        value={this.state.newZipPinCode}
                        onChange={this.handleInputChange}
                        maxLength="6"
                      />
                      {errors["newZipPinCode"] && (
                    <span className="text-danger">{errors["newZipPinCode"]}</span>
                  )}
                    </Form.Group>
                  </Col>
                </Row>
                  </Col>
                </Row>

                <div className="text-center mt-2">
                  <Button
                    variant="secondary"
                    className="btn-primary"
                    onClick={(e) => {
                      this.submitNewInstitute(e);
                    }}
                    disabled={this.state.isSubmitting}
                  >
                    <FaPlus className="mr-2 mb-1" style={{ verticalAlign: "bottom" }} />
                    Add Institute
                  </Button>
                </div>
              </Container>
            </Modal.Body>
          </Modal>
          </Col>
        </Row>
      </section>
    );
  }
}